import { daysUntilLicenseExpiry } from './days-until-license-expiry.js';
import { isLicenseExpired } from './is-license-expired.js';
const EXPIRING_SOON_DAYS = 30;
/** `today` is the Pacific business date; expiry dates are compared by calendar day. */
export function licenseExpiryTone(expiresAt, today) {
    if (expiresAt === null)
        return 'default';
    if (isLicenseExpired(expiresAt, today))
        return 'expired';
    const daysLeft = daysUntilLicenseExpiry(expiresAt, today);
    return daysLeft > 0 && daysLeft <= EXPIRING_SOON_DAYS ? 'expiringSoon' : 'default';
}
//# sourceMappingURL=license-expiry-tone.js.map